"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Text = _ref => {
  let {
    className,
    children,
    color,
    bold,
    small,
    headingSize,
    inline,
    block,
    ellipsis,
    margin,
    marginTop,
    marginBottom,
    title,
    ...props
  } = _ref;
  const elementRef = (0, _react.useRef)(null);
  const [theTitle, setTitle] = (0, _react.useState)(title);
  (0, _react.useEffect)(() => {
    if (title || !ellipsis) return;
    setTitle(elementRef.current.innerText);
  }, [elementRef, title, ellipsis]);
  function htmlElement() {
    if (small) return "small";
    switch (headingSize) {
      case 1:
        return "h1";
      case 2:
        return "h2";
      case 3:
        return "h3";
      case 4:
        return "h4";
      case 5:
        return "h5";
      default:
        return "p";
    }
  }
  var Element = htmlElement();
  var marginClass = (0, _classnames.default)({
    "arc3-margin--top": marginTop || margin,
    "arc3-margin--bottom": marginBottom || margin
  });
  var classes = (0, _classnames.default)("arc3-text", {
    "arc3-text--inline": inline,
    "arc3-text--block": block,
    "arc3-text--ellipsis": ellipsis,
    ["arc3-text--color-brand-".concat(color)]: color,
    "arc3-typo--font-bold": bold
  }, marginClass, className);
  return /*#__PURE__*/_react.default.createElement(Element, _extends({
    className: classes,
    title: theTitle,
    ref: elementRef
  }, props), children);
};
exports.Text = Text;
Text.propTypes = {
  /** Button content */
  children: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.node, _propTypes.PropTypes.string]),
  /** Set the text to bold font weight */
  bold: _propTypes.PropTypes.bool,
  /** Set the text size to small */
  small: _propTypes.PropTypes.bool,
  /** Set the text to larger, 1 biggest, 5 smallest */
  headingSize: _propTypes.PropTypes.number,
  /** set display to inline */
  inline: _propTypes.PropTypes.bool,
  /** set display to block */
  block: _propTypes.PropTypes.bool,
  /** sets no wrap & overflow ellipsis */
  ellipsis: _propTypes.PropTypes.bool,
  /** default margin */
  margin: _propTypes.PropTypes.bool,
  /** default margin to top only */
  marginTop: _propTypes.PropTypes.bool,
  /** default margin to bottom only */
  marginBottom: _propTypes.PropTypes.bool,
  /** Set the text colour to a brand */
  color: _propTypes.PropTypes.oneOf(["orange", "blue", "pink", "cyan", "yellow", "purple", "red", "white"])
};